// extracted by mini-css-extract-plugin
module.exports = {"container":"EsqueciSenhaOk_container__19pd6","content":"EsqueciSenhaOk_content__T4Mrd","margin":"EsqueciSenhaOk_margin__2VWZ2"};